export const manufacturingData = {
  id: 'manufacturing',
  title: '制造业能源管理解决方案',
  subtitle: '从车间到全厂，实现精细化能耗管控与碳排放追踪',
  heroImage: 'https://readdy.ai/api/search-image?query=modern%20smart%20manufacturing%20factory%20interior%20with%20digital%20energy%20monitoring%20screens%20holographic%20data%20overlays%20robotic%20arms%20CNC%20machines%20clean%20organized%20production%20line%20green%20LED%20indicators%20professional%20industrial%20photography%20dark%20ambient%20lighting&width=1200&height=500&seq=indm1&orientation=landscape',
  stats: [
    { value: '32%', label: '平均节能率', trend: 'up' },
    { value: '60%', label: '设备故障率降低', trend: 'down' },
    { value: '8个月', label: '平均ROI周期', trend: 'up' },
    { value: '800+', label: '单厂接入设备数', trend: 'up' },
  ],
  painPoints: [
    {
      icon: 'ri-file-list-3-line',
      title: '能耗数据滞后',
      description: '传统人工抄表周期3-7天，无法及时发现能耗异常，错失优化窗口期',
    },
    {
      icon: 'ri-error-warning-line',
      title: '设备故障频发',
      description: '高耗能设备缺乏预测性维护，非计划停机导致产能损失和维修成本激增',
    },
    {
      icon: 'ri-bar-chart-box-line',
      title: '工序能耗不透明',
      description: '无法精确追踪每道工序的单位产品能耗，工艺优化缺乏数据支撑',
    },
    {
      icon: 'ri-leaf-line',
      title: '碳排放核算困难',
      description: '缺乏全链路碳排放数据采集体系，绿色工厂申报和碳合规面临挑战',
    },
  ],
  features: [
    {
      icon: 'ri-dashboard-3-line',
      title: '全厂级实时监测',
      description: '毫秒级数据采集，覆盖电、水、气、热等多能源类型，支持800+设备同时在线监测。',
      highlights: ['毫秒级数据更新', '多能源统一管理', '800+设备并发'],
    },
    {
      icon: 'ri-brain-line',
      title: 'AI 工序级能耗分析',
      description: '基于深度学习算法，自动识别高耗能工序，提供精准的工艺优化建议，实现能耗与产量的最优平衡。',
      highlights: ['工序级能耗追踪', 'AI工艺优化', '产量能耗平衡'],
    },
    {
      icon: 'ri-tools-line',
      title: '预测性设备维护',
      description: 'AI预测设备故障风险，提前7-30天预警维护需求，减少非计划停机，延长设备使用寿命。',
      highlights: ['提前7-30天预警', '故障率降低60%', '延长设备寿命'],
    },
    {
      icon: 'ri-leaf-line',
      title: '绿色工厂认证支持',
      description: '自动生成绿色工厂自评价报告，提供ISO 50001能源管理体系认证辅导，助力企业获得政策红利。',
      highlights: ['自评价报告自动生成', 'ISO 50001辅导', '200+认证案例'],
    },
    {
      icon: 'ri-file-chart-line',
      title: '智能能耗对标分析',
      description: '与国家能耗限额标准自动对标，识别超标环节，提供针对性优化方案，确保合规达标。',
      highlights: ['国家限额对标', '超标自动预警', '优化方案推荐'],
    },
    {
      icon: 'ri-apps-line',
      title: '企业工具无缝集成',
      description: '无缝对接钉钉、飞书、企业微信，告警实时推送，报告自动分发，让能源管理融入日常办公。',
      highlights: ['钉钉/飞书集成', '告警实时推送', '报告自动分发'],
    },
  ],
  architecture: {
    title: '制造业能源管理架构',
    description: '从设备层到应用层的全栈解决方案',
    layers: [
      { name: '应用层', items: ['能耗看板', 'AI分析', '预测维护', '碳排放追踪', '智能报告'] },
      { name: '平台层', items: ['数据采集引擎', 'AI算法引擎', '规则引擎', '报表引擎', '集成网关'] },
      { name: '边缘层', items: ['边缘网关', '协议转换', '数据预处理', '本地缓存', '断点续传'] },
      { name: '设备层', items: ['电表', '水表', '气表', '传感器', 'PLC/DCS'] },
    ],
  },
  caseStudy: {
    company: '华能精密制造集团',
    industry: '精密制造',
    logo: 'https://readdy.ai/api/search-image?query=modern%20precision%20manufacturing%20factory%20interior%20with%20CNC%20machines%20clean%20organized%20production%20line%20professional%20industrial%20photography&width=400&height=250&seq=cd1&orientation=landscape',
    result: '节能 32%',
    metric: '年节约电费 860万元',
    period: '2023.03 - 2024.03',
    challenge: '拥有12个生产车间、800+台高耗能设备，能源管理依赖人工抄表，数据滞后3-7天，年度电费支出超过2600万元。',
    solution: '部署Firmai实时监测平台，接入800+设备传感器，AI分析引擎自动识别高耗能设备，预测性维护模块提前预警设备故障。',
    results: [
      { label: '年度节能', value: '32%' },
      { label: '节约电费', value: '860万/年' },
      { label: '设备故障率', value: '降低60%' },
      { label: '碳排放减少', value: '2800吨/年' },
      { label: 'ROI回报周期', value: '8个月' },
      { label: '数据更新延迟', value: '<100ms' },
    ],
    quote: 'Firmai平台帮助我们实现了全厂能源的精细化管理，AI预测性维护功能让设备故障率降低了60%。现在我们的能源数据实时可见，决策效率提升了3倍。',
    quoteAuthor: '张明华',
    quoteTitle: '能源管理总监',
    quoteAvatar: 'https://readdy.ai/api/search-image?query=professional%20asian%20male%20business%20executive%20portrait%20headshot%20wearing%20suit%20confident%20smile%20clean%20background%20corporate%20photography&width=80&height=80&seq=cda1&orientation=squarish',
  },
  ctaTitle: '让制造业能源管理更智能',
  ctaSubtitle: '无论您是精密制造、汽车零部件还是电子组装，Firmai都能为您量身定制能源管理解决方案',
};

export const logisticsData = {
  id: 'logistics',
  title: '物流仓储能源管理解决方案',
  subtitle: '全链路碳排放追踪，打造绿色智慧物流网络',
  heroImage: 'https://readdy.ai/api/search-image?query=modern%20automated%20logistics%20warehouse%20with%20robotic%20sorting%20systems%20conveyor%20belts%20smart%20energy%20monitoring%20screens%20green%20LED%20indicators%20clean%20bright%20interior%20professional%20industrial%20photography&width=1200&height=500&seq=indl1&orientation=landscape',
  stats: [
    { value: '28%', label: '碳排放降低', trend: 'down' },
    { value: '15%', label: '运输效率提升', trend: 'up' },
    { value: '40%', label: '合规成本降低', trend: 'down' },
    { value: '200+', label: '分拣中心覆盖', trend: 'up' },
  ],
  painPoints: [
    {
      icon: 'ri-truck-line',
      title: '运输碳排放难追踪',
      description: '物流车队碳排放占总量65%，缺乏实时追踪手段，无法满足客户绿色供应链认证要求',
    },
    {
      icon: 'ri-store-2-line',
      title: '仓储能耗管理粗放',
      description: '分拣中心照明、空调、传送带等系统独立运行，缺乏统一调度，能耗浪费严重',
    },
    {
      icon: 'ri-shield-check-line',
      title: '绿色认证门槛高',
      description: '缺乏统一的碳排放核算体系，ISO 14064等绿色认证申报流程复杂、周期长',
    },
    {
      icon: 'ri-route-line',
      title: '运输路线优化不足',
      description: '传统路线规划未考虑能耗因素，空驶率高，燃油成本居高不下',
    },
  ],
  features: [
    {
      icon: 'ri-route-line',
      title: '运输碳排放实时追踪',
      description: '基于GPS和车载传感器，实时追踪每辆车的碳排放数据，覆盖仓储、运输、配送全链路。',
      highlights: ['GPS实时追踪', '全链路覆盖', '碳排放可视化'],
    },
    {
      icon: 'ri-map-pin-line',
      title: '智能路线优化',
      description: 'AI算法综合考虑路况、载重、能耗等因素，自动规划最优运输路线，降低燃油消耗。',
      highlights: ['AI路线规划', '油耗降低15%', '实时路况适配'],
    },
    {
      icon: 'ri-store-2-line',
      title: '分拣中心能耗管理',
      description: '统一监控分拣中心照明、空调、传送带等系统，AI智能调度根据货量自动调节设备运行。',
      highlights: ['多系统统一管理', 'AI智能调度', '货量自适应'],
    },
    {
      icon: 'ri-award-line',
      title: '绿色供应链认证',
      description: '自动生成碳足迹报告，对接ISO 14064等绿色认证标准，帮助企业获得绿色供应链资质。',
      highlights: ['碳足迹自动报告', 'ISO 14064对接', '绿色认证辅导'],
    },
    {
      icon: 'ri-file-chart-line',
      title: '客户碳数据透明化',
      description: '为每个客户提供精确的碳足迹数据，支持碳中和承诺，提升客户满意度和品牌竞争力。',
      highlights: ['客户级碳数据', '碳中和支持', '品牌竞争力提升'],
    },
    {
      icon: 'ri-apps-line',
      title: '多网点统一管理',
      description: '支持200+分拣中心、3000+网点统一管理，总部实时查看全网能耗与碳排放数据。',
      highlights: ['200+中心覆盖', '全网实时查看', '分级权限管理'],
    },
  ],
  architecture: {
    title: '物流仓储能源管理架构',
    description: '从车辆到网点的全链路碳管理',
    layers: [
      { name: '应用层', items: ['碳排放看板', '路线优化', '能耗管理', '绿色认证', '客户报告'] },
      { name: '平台层', items: ['车辆数据采集', '仓储数据汇聚', 'AI优化引擎', '碳核算引擎', '集成网关'] },
      { name: '边缘层', items: ['车载终端', '仓储网关', 'GPS定位', '本地缓存', '断点续传'] },
      { name: '设备层', items: ['车辆OBD', '电表', '环境传感器', '传送带PLC', '空调系统'] },
    ],
  },
  caseStudy: {
    company: '顺丰智慧物流',
    industry: '智慧物流',
    logo: 'https://readdy.ai/api/search-image?query=modern%20automated%20logistics%20warehouse%20with%20robotic%20sorting%20systems%20conveyor%20belts%20bright%20interior%20professional%20industrial%20photography&width=400&height=250&seq=cd2&orientation=landscape',
    result: '减排 5000吨/年',
    metric: '碳排放降低 28%',
    period: '2022.08 - 2024.08',
    challenge: '在全国拥有200+分拣中心和3000+网点，物流车队碳排放占总量65%，缺乏统一的碳排放核算体系。',
    solution: '建立全链路碳排放追踪系统，覆盖仓储、运输、配送各环节。自动生成碳足迹报告，对接绿色供应链认证标准。',
    results: [
      { label: '年度减排', value: '5000吨' },
      { label: '碳排放降低', value: '28%' },
      { label: '绿色认证', value: 'ISO 14064' },
      { label: '运输效率', value: '提升15%' },
      { label: '客户满意度', value: '+22%' },
      { label: '合规成本', value: '降低40%' },
    ],
    quote: '通过Firmai的碳排放追踪功能，我们成功获得了绿色供应链认证，客户满意度显著提升。现在我们可以向每个客户展示精确的碳足迹数据。',
    quoteAuthor: '李雪婷',
    quoteTitle: '可持续发展负责人',
    quoteAvatar: 'https://readdy.ai/api/search-image?query=professional%20asian%20female%20business%20executive%20portrait%20headshot%20wearing%20blazer%20confident%20smile%20clean%20background%20corporate%20photography&width=80&height=80&seq=cda2&orientation=squarish',
  },
  ctaTitle: '打造绿色智慧物流网络',
  ctaSubtitle: '从仓储到配送，全链路碳排放追踪与管理，助力物流企业实现绿色转型',
};

export const datacenterData = {
  id: 'datacenter',
  title: '数据中心能源管理解决方案',
  subtitle: 'AI驱动冷却优化，PUE精细化管理，打造绿色数据中心',
  heroImage: 'https://readdy.ai/api/search-image?query=modern%20data%20center%20server%20room%20with%20rows%20of%20servers%20blue%20LED%20lights%20smart%20cooling%20systems%20digital%20energy%20monitoring%20holographic%20overlays%20professional%20tech%20photography%20dark%20ambient%20lighting%20futuristic%20atmosphere&width=1200&height=500&seq=indd1&orientation=landscape',
  stats: [
    { value: '1.25', label: 'PUE优化目标', trend: 'down' },
    { value: '28%', label: '冷却能耗降低', trend: 'down' },
    { value: '95%', label: '宕机时间减少', trend: 'down' },
    { value: '1200万', label: '年省电费(元)', trend: 'up' },
  ],
  painPoints: [
    {
      icon: 'ri-temp-hot-line',
      title: 'PUE居高不下',
      description: '传统数据中心PUE长期维持在1.45以上，冷却系统能耗占总量40%，缺乏精细化调控手段',
    },
    {
      icon: 'ri-shut-down-line',
      title: '制冷故障导致宕机',
      description: '制冷设备故障是数据中心宕机的主要原因之一，缺乏预测性维护手段，风险难以管控',
    },
    {
      icon: 'ri-server-line',
      title: '服务器负载不均',
      description: '服务器负载分布不均导致局部热点，传统冷却策略无法精准匹配实际热负荷分布',
    },
    {
      icon: 'ri-leaf-line',
      title: '绿色等级认证困难',
      description: '数据中心绿色等级认证对PUE、可再生能源使用比例等有严格要求，达标难度大',
    },
  ],
  features: [
    {
      icon: 'ri-temp-cold-line',
      title: 'AI冷却优化系统',
      description: '实时分析服务器负载与温度分布，AI动态调节冷却塔与精密空调运行策略，实现PUE最优。',
      highlights: ['负载温度实时分析', 'AI动态调节', 'PUE最优控制'],
    },
    {
      icon: 'ri-dashboard-3-line',
      title: 'PUE实时监测与对标',
      description: '毫秒级PUE计算与监测，与国家绿色数据中心标准自动对标，超标实时告警。',
      highlights: ['毫秒级PUE计算', '国家标准对标', '超标实时告警'],
    },
    {
      icon: 'ri-tools-line',
      title: '制冷设备预测性维护',
      description: 'AI预测制冷设备故障风险，提前预警维护需求，避免因制冷故障导致的服务器宕机。',
      highlights: ['故障提前预警', '宕机风险规避', '维护成本降低'],
    },
    {
      icon: 'ri-server-line',
      title: '服务器负载均衡优化',
      description: '实时监测服务器负载分布，AI推荐负载迁移策略，消除局部热点，提升冷却效率。',
      highlights: ['负载分布监测', '热点消除', '冷却效率提升'],
    },
    {
      icon: 'ri-award-line',
      title: '绿色数据中心认证',
      description: '自动生成绿色数据中心认证所需报告，提供5A级绿色数据中心申报全流程支持。',
      highlights: ['认证报告自动生成', '5A级申报支持', '绿色等级提升'],
    },
    {
      icon: 'ri-flashlight-line',
      title: '可再生能源管理',
      description: '整合光伏、储能等可再生能源数据，优化绿电使用策略，提升可再生能源使用比例。',
      highlights: ['光伏储能整合', '绿电策略优化', '可再生能源追踪'],
    },
  ],
  architecture: {
    title: '数据中心能源管理架构',
    description: '从基础设施到智能优化的全栈方案',
    layers: [
      { name: '应用层', items: ['PUE看板', '冷却优化', '预测维护', '负载均衡', '绿电管理'] },
      { name: '平台层', items: ['热力学模型', 'AI优化引擎', '故障预测', '负载调度', '碳核算'] },
      { name: '边缘层', items: ['机房网关', 'BMS对接', 'UPS监控', '本地缓存', '断点续传'] },
      { name: '设备层', items: ['精密空调', '冷却塔', 'UPS', 'PDU', '环境传感器'] },
    ],
  },
  caseStudy: {
    company: '腾讯云数据中心',
    industry: '数据中心',
    logo: 'https://readdy.ai/api/search-image?query=modern%20data%20center%20server%20room%20with%20rows%20of%20servers%20blue%20LED%20lights%20cooling%20systems%20professional%20tech%20photography&width=400&height=250&seq=cd4&orientation=landscape',
    result: 'PUE 降至 1.25',
    metric: '年省电费 1200万元',
    period: '2023.06 - 2024.12',
    challenge: '华南区最大数据中心，IT负载50MW，PUE长期维持在1.45以上。冷却系统能耗占总量40%，缺乏精细化调控手段。',
    solution: '部署AI冷却优化系统，实时分析服务器负载与温度分布，动态调节冷却塔与精密空调运行策略。预测性维护避免制冷设备故障导致的宕机风险。',
    results: [
      { label: 'PUE优化', value: '1.25' },
      { label: '年省电费', value: '1200万' },
      { label: '冷却能耗', value: '降低28%' },
      { label: '宕机时间', value: '减少95%' },
      { label: '碳减排', value: '8000吨/年' },
      { label: '绿色等级', value: '5A' },
    ],
    quote: 'Firmai的AI冷却优化让我们的PUE从1.45降到1.25，这在华南地区是领先水平。预测性维护功能帮我们避免了3次潜在的制冷系统故障。',
    quoteAuthor: '陈技术',
    quoteTitle: '基础设施总监',
    quoteAvatar: 'https://readdy.ai/api/search-image?query=professional%20asian%20male%20tech%20director%20portrait%20headshot%20wearing%20polo%20shirt%20confident%20clean%20background%20corporate%20photography&width=80&height=80&seq=cda4&orientation=squarish',
  },
  ctaTitle: '打造绿色高效数据中心',
  ctaSubtitle: 'AI驱动冷却优化，PUE精细化管理，让数据中心更绿色、更可靠、更经济',
};

export const industryNavData = [
  { id: 'manufacturing', label: '制造业', href: '/solutions/manufacturing', icon: 'ri-settings-3-line' },
  { id: 'logistics', label: '物流仓储', href: '/solutions/logistics', icon: 'ri-truck-line' },
  { id: 'datacenter', label: '数据中心', href: '/solutions/datacenter', icon: 'ri-server-line' },
];